import React from "react";
import { Menu, MenuItem, IconButton, Stack, Typography } from "@mui/material";
import { useTranslate } from "../../locales/use-locales";

const LANGUAGES = [
  {
    value: "se",
    label: "Svenska",
    flag: "🇸🇪",
  },
  {
    value: "en",
    label: "English",
    flag: "🇬🇧",
  },
  {
    value: "de",
    label: "Deutsch",
    flag: "🇩🇪",
  },
  {
    value: "fi",
    label: "Suomi",
    flag: "🇫🇮",
  },
];

export default function LanguageSelector() {
  const { currentLang, onChangeLang } = useTranslate();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleChangeLang = (lang) => {
    onChangeLang(lang);
    handleClose();
  };

  const currentLanguage =
    LANGUAGES.find((lang) => lang.value === currentLang.value) || LANGUAGES[0];

  return (
    <>
      <IconButton
        onClick={handleOpen}
        sx={{
          width: "auto",
          height: 40,
          marginLeft: "10px",
          borderRadius: "20px",
          backgroundColor: "rgba(255, 255, 255, 0.1)",
          padding: "0 16px",
          "&:hover": {
            backgroundColor: "rgba(255, 255, 255, 0.2)",
          },
        }}
      >
        <Stack direction="row" alignItems="center" spacing={1}>
          <span
            style={{
              fontSize: "1.4rem",
              filter: "drop-shadow(0 1px 1px rgba(0,0,0,0.1))",
              display: "inline-block",
              transform: "scale(1.1)",
            }}
          >
            {currentLanguage.flag}
          </span>
          <Typography sx={{ color: "black", fontSize: "0.9rem" }}>
            {currentLanguage.label}
          </Typography>
        </Stack>
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        PaperProps={{
          sx: {
            mt: 1.5,
            minWidth: 180,
            backgroundColor: "rgba(255, 255, 255, 0.9)",
            backdropFilter: "blur(8px)",
            top: { xs: "65px !important", sm: "85px !important" },
          },
        }}
      >
        {LANGUAGES.map((option) => (
          <MenuItem
            key={option.value}
            selected={option.value === currentLang.value}
            onClick={() => handleChangeLang(option.value)}
            sx={{
              py: 1,
              px: 2,
              "&.Mui-selected": {
                backgroundColor: "rgba(0, 0, 0, 0.08)",
              },
            }}
          >
            <Stack direction="row" alignItems="center" spacing={1}>
              <span
                style={{
                  fontSize: "1.4rem",
                  filter: "drop-shadow(0 1px 1px rgba(0,0,0,0.1))",
                  display: "inline-block",
                  transform: "scale(1.1)",
                }}
              >
                {option.flag}
              </span>
              <span>{option.label}</span>
            </Stack>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
